import React from "react";
import spinner from "../../images/loadingSpinner.gif";

const Loader = () => {
  return (
    <div className="spinner">
      <img src={spinner} alt="loading-spinner" />
    </div>
  );
};

export default Loader;
